import axiosInstance from '../../../../config/axiosInstance';
import { CommentTemplateValidation } from "../../views/CommentTemplate/Validation/CommentTemplateValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  event.preventDefault();
  const formErrors = CommentTemplateValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      const UserID=localStorage.getItem("UserID");
      formData.ClientID=CompanyID;
      formData.UserID=UserID;
      const response = await axiosInstance.post(`/Setup/CreateCommentTemplate`, formData);
      setFormData({
        vc_Title: '',
        vc_ServiceCode:'',
        vc_Comment:'',
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };